// Generated from config/kambi-operators.json; do not edit by hand.
// Regenerate: UPDATE_KAMBI_OFFERING_HOSTS=1 go test ./apps/shared/pkg/repoqa -run TestKambiOfferingAPIHostsMatchTheCatalog
const offeringApiHosts = new Map<string, 'eu' | 'us'>([
  ['rsicaab', 'us'],
  ['rsimx', 'us'],
  ['rsipe', 'us'],
])

export function offeringApiHost(offering: string): 'eu' | 'us' {
  return offeringApiHosts.get(offering.trim().toLowerCase()) ?? 'eu'
}
